module.exports = __webpack_public_path__ + "2a11413bffa7c492b8ac45c715b40f35.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/feedback-3.png
// module id = 1096
// module chunks = 0